/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getCurrencies } from "api/services/common";
import { ICurrencyOption } from "types/Common";
import { commonQueryKeys } from "./commonQueryKeys";

export function useGetCurrencies(options?: UseQueryOptions<ICurrencyOption[]>) {
  return useQuery({
    queryKey: commonQueryKeys.currencies,
    queryFn: () => getCurrencies().then((res) => res.data),
    ...options,
  });
}
